import React from 'react';
import { Card, Col, Button, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const CompanyHeader = () => {
  return (
    <Card>
      <Card.Body>
        <Row className="flex-between-center">
          <Col md>
            <h5 className="mb-2 mb-md-0">Шинэ компани</h5>
          </Col>
          <Col xs="auto">
            <Button
              variant="link"
              className="text-secondary fw-medium p-0 me-3"
              type="button"
            >
              цуцлах
            </Button>
            <Button
              as={Link}
              to="/company/company-create"
              variant="primary"
              size="sm"
            >
              Компани нэмэх
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CompanyHeader;
